"use client";
import Breadcrumb from "./Breadcrumb";
import ArticleHeader from "./ArticleHeader";
import ArticleImage from "./ArticleImage";
import ArticleContent from "./ArticleContent";
import AuthorInfo from "./AuthorInfo";
import ShareButtons from "./ShareButtons";
import TableOfContents from "./TableOfContents";
import AdditionalContent from "./AdditionalContent";
import TopicTags from "./TopicTags";
import AuthorBio from "./AuthorBio";

export default function NewsArticle({
  breadcrumbs,
  title,
  thumbnail,
  thumbnail_caption,
  content,
  author,
  toc,
  excerpt,
  tags,
  date,
  video_embed,
}) {
  return (
    <>
      <article className="max-w-4xl mx-auto  ">
        <Breadcrumb breadcrumbs={breadcrumbs} />

        <ArticleHeader headline={title} />

        {thumbnail && (
          <ArticleImage
            src={thumbnail}
            alt={title}
            caption={thumbnail_caption}
            video_embed={video_embed}
          />
        )}

        {excerpt && <ArticleContent content={excerpt} />}

        <AuthorInfo
          name={author.name}
          image={author.avatar}
          updatedDate={date}
          username={author?.username}
        />

        <ShareButtons />

        {toc.length > 0 && <TableOfContents items={toc} />}

        {content && <AdditionalContent sections={content} />}

        {tags.length > 0 && <TopicTags tags={tags} />}

        {author && (
          <AuthorBio
            name={author?.name}
            image={author?.avatar}
            bio={author?.bio}
            socialLinks={author?.social}
            username={author?.username}
          />
        )}
      </article>
    </>
  );
}
